import reactComponentLoader from 'scripts/react-component-loader'

import Modular from 'site/Modular'

reactComponentLoader(Modular, '[data-modular-content]')
